import { Component, OnDestroy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UnitsService } from 'app/shared/services/units/units.service';
import * as Highcharts from 'highcharts';

@Component({
    selector: 'app-load-factor-highchart',
    templateUrl: './load-factor-highchart.component.html',
    styleUrls: ['./load-factor-highchart.component.scss'],
    standalone: false
})

export class LoadFactorChartComponent implements OnDestroy, OnChanges {
  chartId: string = 'load-factor-chart-' + Math.random().toString(36).substring(2, 9);
  private chart: Highcharts.Chart | undefined;

  @Input() loadFactor: number = 0;
  @Input() colors: string[];
  @Input() chartSize: number = 37;
  @Input() digitsInfo = '1.0-0';
  @Input() displayName = 'PERFORMANCE_FACTS.LOAD_FACTOR';

  decimalSeparator: string = '.';

  constructor(private unitsService: UnitsService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.loadFactor && !changes.loadFactor.firstChange) {
      this.decimalSeparator = this.unitsService.getDecimalSeparator()
      this.createChart();
    }
  }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  private createChart(): void {
    const remaining = 100 - this.loadFactor;

    const chartOptions: Highcharts.Options = {
      chart: {
        type: 'pie',
        height: this.chartSize,
        width: this.chartSize,
        spacingLeft: 0,
        spacingRight: 0,
        spacingTop: 0,
        spacingBottom: 0,
        backgroundColor: 'transparent',
        margin: [0, 0, 0, 0],
        renderTo: this.chartId
      },
      title: {
        text: null
      },
      tooltip: {
        enabled: false
      },
      plotOptions: {
        pie: {
          size: this.chartSize - 1,
          dataLabels: {
            enabled: false
          },
          borderWidth: 0,
          borderRadius: 0
        },
        series: {
          enableMouseTracking: false
        }
      },
      series: [{
        type: 'pie',
        data: [{
          y: this.loadFactor,
          color: this.colors[0]
        }, {
          y: remaining,
          color: this.colors[1]
        }],
      }],
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      }
    };

    this.chart = Highcharts.chart(this.chartId, chartOptions);
  }
}
